import { gql } from "@apollo/client";
import { useCustomerFacingAccountPlanNavQuery } from "./useHasCustomerFacingAccountPlan.generated";

gql`
  query CustomerFacingAccountPlanNav {
    Me {
      user {
        id
        org {
          id
          customerFacingAccountPlan {
            id
          }
        }
      }
    }
  }
`;

const useHasCustomerFacingAccountPlan = (): boolean => {
  const { data } = useCustomerFacingAccountPlanNavQuery();
  return Boolean(data?.Me?.user.org?.customerFacingAccountPlan?.id);
};

export default useHasCustomerFacingAccountPlan;
